<template>
  <div :class="isDesktop ? 'main-container' : 'main-container mobile'">
    <!-- 공통 헤더 -->
    <div :class="isDesktop ? 'header-title-desktop' : 'header-title-mobile'">누구나 부담없는 가격</div>
    <div :class="isDesktop ? 'header-subtitle-desktop mt-2' : 'header-subtitle-mobile mt-2'">
      무료 상담 받고
      <div class="mobile"></div>
      지금 바로 시작해 보세요
    </div>
    <div :class="['d-flex align-center justify-center', isDesktop ? 'mt-10' : 'mt-6']">
      <TabSelector :activeTab="activeTab" @update:activeTab="updateActiveTab" />
    </div>

    <!-- 매장 데스크톱 페이지 -->
    <div v-if="isDesktop && activeTab === 'store'">
      <NewSubscriptionTopBanner class="mt-10" @click-scroll-to-large-banner="scrollToLargeBanner" />
      <PriceInfo
        class="mt-10 pt-0"
        :selectedPlan="selectedPlan"
        :unit="unit"
        :plans="plans"
        :features="features"
        @update:selectedPlan="updateSelectedPlan" />
      <NewSubscriptionBottomBanner
        ref="newSubscriptionBanner"
        style="margin-top: 120px; margin-bottom: 80px"
        @click-cta="handleClickCta" />
    </div>

    <!-- 매장 모바일 페이지 -->
    <div v-else-if="isMobile && activeTab === 'store'">
      <!-- 신규 사장님을 위한 첫 구독 이벤트 스몰 배너 -->
      <NewSubscriptionTopBannerMobile @click-scroll-to-large-banner="scrollToLargeBanner" />

      <!-- 플랜 카드 -->
      <v-radio-group :value="selectedPlan" @change="updateSelectedPlan">
        <PlanCardMobile
          v-for="(plan, index) in PLAN_LIST"
          :key="plan"
          :class="index !== PLAN_LIST.length - 1 ? 'mb-2' : ''"
          :planData="plans[plan]"
          :features="features"
          :selectedPlan="selectedPlan" />
      </v-radio-group>

      <!-- 첫 구독 이벤트 라지 배너 -->
      <NewSubscriptionBottomBannerMobile ref="largeBannerMobile" @click-cta="handleClickCta" />
    </div>

    <!-- 제품 데스크톱 페이지 -->
    <div v-if="isDesktop && activeTab === 'product'">
      <ProductPriceInfo
        class="mt-10 pt-0"
        :packages="packages"
        :selectedPackage="selectedPackage"
        :features="productFeatures"
        @update:selectedPackage="selectedPackage = $event" />
    </div>

    <!-- 제품 모바일 페이지 -->
    <div v-else-if="isMobile && activeTab === 'product'" class="mobile-product-container">
      <v-radio-group :value="selectedPackage" @change="updateSelectedPackage">
        <PackageCardMobile
          v-for="(packageNumber, index) in PACKAGE_LIST"
          :key="packageNumber"
          :class="index !== PACKAGE_LIST.length - 1 ? 'mb-2' : ''"
          :packageData="packages[packageNumber]"
          :productFeatures="productFeatures"
          :selectedPackage="selectedPackage" />
      </v-radio-group>
    </div>

    <!-- 모달 -->
    <CtaModal
      v-show="!isNewSubscriptionBannerFullyVisible && isDesktop"
      class="mt-10"
      :type="activeTab"
      :plans="plans"
      :selectedPlan="selectedPlan"
      :packages="packages"
      :selectedPackage="selectedPackage"
      @click-free-trial="handleClickFreeTrial" />
    <!-- 바텀시트  -->
    <CtaBottomSheet
      v-show="isMobile && !isLargeBannerVisible"
      :activeTab="activeTab"
      :plans="plans"
      :packages="packages"
      :selectedPackage="selectedPackage"
      :selectedPlan="selectedPlan"
      @click-free-trial="handleClickFreeTrial" />

    <!-- 도입문의 모달 -->
    <LeadModal
      :type="activeTab === 'store' ? 'STORE' : 'PRODUCT'"
      :showModal="showLeadModal"
      :selectedPlan="selectedPlan"
      :selectedPackage="selectedPackage"
      @update:showModal="showLeadModal = $event"
      sourceRoute="price" />
  </div>
</template>

<script>
import TabSelector from '@/components/landing/priceGuide/TabSelector.vue';
import PriceInfo from '@/components/landing/priceGuide/PriceInfo.vue';
import ProductPriceInfo from '@/components/landing/priceGuide/ProductPriceInfo.vue';
import PlanCardMobile from '@/components/landing/priceGuide/PlanCardMobile.vue';
import LeadModal from '@/components/landing/modal/LeadModal.vue';
import PackageCardMobile from '@/components/landing/priceGuide/PackageCardMobile.vue';
import NewSubscriptionTopBanner from '@/components/landing/priceGuide/NewSubscriptionTopBanner.vue';
import NewSubscriptionBottomBanner from '@/components/landing/priceGuide/NewSubscriptionBottomBanner.vue';
import NewSubscriptionTopBannerMobile from '@/components/landing/priceGuide/NewSubscriptionTopBannerMobile.vue';
import NewSubscriptionBottomBannerMobile from '@/components/landing/priceGuide/NewSubscriptionBottomBannerMobile.vue';
import CtaModal from '@/components/landing/priceGuide/CtaModal.vue';
import CtaBottomSheet from '@/components/landing/priceGuide/CtaBottomSheet.vue';

import { STORE_DEAFULT_PLAN_LIST } from '@/constants/ad';
import { PRODUCT_PACKAGE_LIST } from '@/constants/ad';
import { pushDataLayer } from '@/utils';

const scrollCheckPoint = { 0.25: 0, 0.5: 0, 0.75: 0, 0.9: 0 };

export default {
  name: 'Price',
  components: {
    TabSelector,
    NewSubscriptionTopBanner,
    NewSubscriptionBottomBanner,
    NewSubscriptionTopBannerMobile,
    NewSubscriptionBottomBannerMobile,
    PriceInfo,
    ProductPriceInfo,
    PlanCardMobile,
    CtaModal,
    CtaBottomSheet,
    LeadModal,
    PackageCardMobile,
  },
  data() {
    return {
      activeTab: 'store',
      PLAN_LIST: STORE_DEAFULT_PLAN_LIST,
      PACKAGE_LIST: PRODUCT_PACKAGE_LIST,
      selectedPlan: 1,
      selectedPackage: 15,
      isNewSubscriptionBannerFullyVisible: false,
      isLargeBannerVisible: false,
      showLeadModal: false,
      intersectionObserver: null,
      largeBannerObserver: null,
      resizeTimer: null,
      plans: {
        1: {
          id: 1,
          title: '1개월 플랜',
          price: '15만원',
          priceNumber: 150000,
          originalPrice: null,
          discount: null,
          features: [
            {
              title: 'atLeastCount',
              value: 8,
              type: 'value',
            },
            {
              title: 'stopAdCount',
              value: '-',
              type: 'value',
            },
            {
              title: 'blogKeywordBasicConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'placeKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'googleReview',
              value: true,
              type: 'check',
            },
            {
              title: 'oneLineReview',
              value: true,
              type: 'check',
            },
            {
              title: 'unlimitedTopInfluencer',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordStrategyConsulting',
              value: false,
              type: 'check',
            },
            {
              title: 'placeKeywordConsulting',
              value: false,
              type: 'check',
            },
            {
              title: 'placeOperationGuidebook',
              value: false,
              type: 'check',
            },
          ],
        },
        6: {
          id: 6,
          title: '6개월 플랜',
          price: '13.5만원',
          priceNumber: 135000,
          originalPrice: '150,000원',
          discount: 10,
          features: [
            {
              title: 'atLeastCount',
              value: 48,
              type: 'value',
            },
            {
              title: 'stopAdCount',
              value: 1,
              type: 'value',
            },
            {
              title: 'blogKeywordBasicConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'placeKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'googleReview',
              value: true,
              type: 'check',
            },
            {
              title: 'oneLineReview',
              value: true,
              type: 'check',
            },
            {
              title: 'unlimitedTopInfluencer',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordStrategyConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'placeKeywordConsulting',
              value: false,
              type: 'check',
            },
            {
              title: 'placeOperationGuidebook',
              value: false,
              type: 'check',
            },
          ],
        },
        12: {
          id: 12,
          title: '12개월 플랜',
          price: '12만원',
          priceNumber: 120000,
          originalPrice: '150,000원',
          discount: 20,
          features: [
            {
              title: 'atLeastCount',
              value: 96,
              type: 'value',
            },
            {
              title: 'stopAdCount',
              value: 2,
              type: 'value',
            },
            {
              title: 'blogKeywordBasicConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'placeKeywordRankReport',
              value: true,
              type: 'check',
            },
            {
              title: 'googleReview',
              value: true,
              type: 'check',
            },
            {
              title: 'oneLineReview',
              value: true,
              type: 'check',
            },
            {
              title: 'unlimitedTopInfluencer',
              value: true,
              type: 'check',
            },
            {
              title: 'blogKeywordStrategyConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'placeKeywordConsulting',
              value: true,
              type: 'check',
            },
            {
              title: 'placeOperationGuidebook',
              value: true,
              type: 'check',
            },
          ],
        },
      },

      packages: {
        15: {
          id: 15,
          title: '체험형 패키지',
          price: '15만원',
          priceNumber: 150000,
          perPerson: '15,000원',
          features: [
            {
              title: 'month',
              value: 1,
              type: 'value',
            },
            {
              title: 'numberOfPeople',
              value: 10,
              type: 'value',
            },
          ],
        },
        100: {
          id: 100,
          title: '100만원 패키지',
          price: '100만원',
          priceNumber: 1000000,
          perPerson: '10,000원',
          features: [
            {
              title: 'month',
              value: 6,
              type: 'value',
            },
            {
              title: 'numberOfPeople',
              value: 100,
              type: 'value',
            },
          ],
        },
        500: {
          id: 500,
          title: '500만원 패키지',
          price: '500만원',
          priceNumber: 5000000,
          perPerson: '7,500원',
          features: [
            {
              title: 'month',
              value: 12,
              type: 'value',
            },
            {
              title: 'numberOfPeople',
              value: 710,
              type: 'value',
            },
          ],
        },
        1000: {
          id: 1000,
          title: '1000만원 패키지',
          price: '1000만원',
          priceNumber: 10000000,
          perPerson: '5,000원',
          features: [
            {
              title: 'month',
              value: 12,
              type: 'value',
            },
            {
              title: 'numberOfPeople',
              value: 2000,
              type: 'value',
            },
          ],
        },
      },

      unit: {
        atLeastCount: '명',
        stopAdCount: '회',
      },

      features: [
        {
          title: '최소 모집 인원 보장',
          description: '기간 연장',
          tooltip: '목표 인원이 모일 때까지 무료로 모집 기간을 연장해 드려요.',
        },
        {
          title: '광고 일시중단',
          description: '최대 30일',
          tooltip: '원하실 때 최대 30일까지, 구독을 유지한 채로 광고를 잠시 멈출 수 있어요.',
        },
        {
          title: '블로그 키워드 기초 컨설팅',
          tooltip: '업종·지역 기반 핵심 키워드 점검 및 기본 세팅을 컨설팅해 드려요.',
        },
        {
          title: '블로그 키워드 순위 리포트',
          tooltip: '블로거들이 작성한 포스팅이 어떤 키워드에 몇 위로 노출되는지 확인할 수 있어요.',
        },
        {
          title: '플레이스 키워드 순위 리포트',
          tooltip: '내 매장의 플레이스 키워드 순위를 실시간·일자별로 기록해 볼 수 있어요.',
        },
        {
          title: '구글 맵 리뷰 제공',
          tooltip: '우리 매장을 방문한 블로거들이 구글 맵 리뷰를 직접 작성해줘요.',
        },
        {
          title: '매장 비공개 한줄평',
          tooltip: '내 매장에 대한 솔직한 한줄평을 비공개로 받을 수 있어요.',
        },
        {
          title: '상위 블로거 무제한 모집',
          tooltip: '구독 시 상위 블로거를 인원 제한 없이 모집할 수 있어요.',
        },
        {
          title: '블로그 키워드 전략 컨설팅',
          tooltip: '매장에 최적화된 블로그 키워드 전략을 전문가가 제안해 드려요.',
        },
        {
          title: '플레이스 키워드 컨설팅',
          tooltip: '플레이스 키워드를 선정·최적화하는 전략을 전문가가 안내해 드려요.',
        },
        {
          title: '플레이스 운영 가이드북 제공',
          tooltip: '2년간 분석한 플레이스 운영 비법 가이드북을 드려요.',
        },
      ],
      productFeatures: [
        {
          title: '기간',
        },
        {
          title: '인원',
        },
      ],
    };
  },

  mounted() {
    this.setupIntersectionObserver();
    this.setupLargeBannerObserver();

    // 윈도우 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },

  watch: {
    /**
     * activeTab이 변경될 때 Intersection Observer를 재설정합니다
     */
    activeTab: {
      handler() {
        // DOM 업데이트 후에 Observer 재설정
        this.$nextTick(() => {
          this.setupIntersectionObserver();
          this.setupLargeBannerObserver();
        });
      },
      immediate: false,
    },

    /**
     * 뷰포트 크기 변경 시 Observer 재설정
     */
    isDesktop: {
      handler() {
        this.$nextTick(() => {
          this.setupIntersectionObserver();
          this.setupLargeBannerObserver();
        });
      },
      immediate: false,
    },
  },

  beforeDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    if (this.largeBannerObserver) {
      this.largeBannerObserver.disconnect();
    }
    // 윈도우 이벤트 리스너 제거
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },

  created() {
    pushDataLayer({
      event: 'viewPricePage',
      page: 'price',
    });
  },

  methods: {
    /**
     * Intersection Observer를 설정하여 NewSubscriptionBanner의 가시성을 추적합니다
     */
    setupIntersectionObserver() {
      // 기존 Observer가 있다면 정리
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }

      // 매장 탭이 아니거나 NewSubscriptionBanner 요소가 존재하지 않으면 Observer 설정하지 않음
      if (this.activeTab !== 'store' || !this.$refs.newSubscriptionBanner?.$el) {
        // 매장 탭이 아닐 때는 FloatingBanner를 보이게 함
        this.isNewSubscriptionBannerFullyVisible = false;
        return;
      }

      // Intersection Observer 옵션 설정
      const options = {
        root: null, // viewport를 기준으로 함
        rootMargin: '0px',
        threshold: 1.0, // 100% 보일 때 트리거
      };

      // Observer 콜백 함수
      const callback = entries => {
        entries.forEach(entry => {
          // NewSubscriptionBanner가 100% 보이는지 확인
          this.isNewSubscriptionBannerFullyVisible = entry.intersectionRatio >= 1.0;
        });
      };

      // Observer 생성 및 관찰 시작
      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this.$refs.newSubscriptionBanner.$el);
    },

    /**
     * LargeBannerMobile의 가시성을 추적하여 BottomSheet 표시/숨김을 제어합니다
     */
    setupLargeBannerObserver() {
      // 기존 Observer가 있다면 정리
      if (this.largeBannerObserver) {
        this.largeBannerObserver.disconnect();
        this.largeBannerObserver = null;
      }

      // 매장 탭이 아니거나 모바일이 아니거나 LargeBanner 요소가 존재하지 않으면 Observer 설정하지 않음
      if (this.activeTab !== 'store' || this.isDesktop || !this.$refs.largeBannerMobile?.$el) {
        this.isLargeBannerVisible = false;
        return;
      }

      // Intersection Observer 옵션 설정
      const options = {
        root: null, // viewport를 기준으로 함
        rootMargin: '0px',
        threshold: 0.1, // 10% 보일 때 트리거
      };

      // Observer 콜백 함수
      const callback = entries => {
        entries.forEach(entry => {
          // LargeBanner가 10% 이상 보이는지 확인
          this.isLargeBannerVisible = entry.intersectionRatio >= 0.1;
        });
      };

      // Observer 생성 및 관찰 시작
      this.largeBannerObserver = new IntersectionObserver(callback, options);
      this.largeBannerObserver.observe(this.$refs.largeBannerMobile.$el);
    },

    updateActiveTab(tab) {
      pushDataLayer({
        event: 'clickTab',
        page: 'price',
        objectSection: 'tabbar',
        objectType: 'tab',
        objectId: tab,
        objectName: tab === 'store' ? '매장' : '제품',
      });

      this.activeTab = tab;

      // 탭 변경 후 DOM 업데이트를 기다린 다음 Observer 재설정
      this.$nextTick(() => {
        this.setupIntersectionObserver();
      });
    },
    updateSelectedPlan(selectedValue) {
      this.selectedPlan = selectedValue;
      pushDataLayer({
        event: 'selectPlan',
        page: 'price',
        objectSection: 'priceCard',
        objectType: 'radioButton',
        objectId: `plan${selectedValue}`,
        objectName: `plan${selectedValue}`,
      });
    },
    updateSelectedPackage(selectedValue) {
      this.selectedPackage = selectedValue;
    },
    handleClickFreeTrial() {
      // 도입문의 모달 띄우기

      pushDataLayer({
        event: 'clickLeadCta',
        page: 'price',
        objectType: 'button',
        objectSection: 'floating',
        objectId: 'openLeadForm',
        objectName: '무료 상담하기',
      });
      this.showLeadModal = true;
    },

    scrollToLargeBanner() {
      pushDataLayer({
        event: 'clickViewBenefitsBtn',
        page: 'price',
        objectSection: 'promotionBanner',
        objectType: 'button',
        objectId: 'viewBenefits',
        objectName: '혜택 자세히 보기',
      });

      if (this.isDesktop) {
        const bottom = document.body.scrollHeight;
        window.scrollTo({ top: bottom, behavior: 'smooth' });
        return;
      }

      // LargeBannerMobile 요소로 부드럽게 스크롤
      if (this.$refs.largeBannerMobile && this.$refs.largeBannerMobile.$el) {
        const element = this.$refs.largeBannerMobile.$el;
        const elementTop = element.offsetTop;
        const offsetPosition = elementTop - 20; // 상단 여백 20px 추가

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },

    /**
     * 윈도우 리사이즈 시 호출되는 핸들러
     */
    handleResize() {
      // 디바운스를 위해 타이머 사용
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.setupIntersectionObserver();
          this.setupLargeBannerObserver();
        });
      }, 300);
    },

    handleScroll() {
      // 현재 스크롤된 위치 (px)
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // 화면 높이 (px)
      const windowHeight = window.innerHeight;

      // 문서 전체 높이 (px)
      const docHeight = document.documentElement.scrollHeight;

      // 스크롤 진행률 (0 ~ 1)
      const scrollPercent = scrollTop / (docHeight - windowHeight);

      Object.keys(scrollCheckPoint).forEach(targetScrollPercent => {
        if (scrollPercent >= targetScrollPercent && scrollCheckPoint[targetScrollPercent] === 0) {
          scrollCheckPoint[targetScrollPercent] = 1;
          pushDataLayer({
            event: 'scrollDepthReached',
            page: 'price',
            scrollDepth: targetScrollPercent * 100,
          });
        }
      });
    },

    // 신규 혜택 받는 회원가입 페이지로 이동
    handleClickCta() {
      pushDataLayer({
        event: 'clickSignupCta',
        page: 'price',
        objectSection: 'promotionDetail',
        objectType: 'button',
        objectId: 'getFirstBenefit',
        objectName: '신규 전용 혜택 받기',
      });

      this.$router.push('/signup?event=first_subscription');
    },
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isMobile() {
      return !this.isDesktop;
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  margin: 0 auto;
  padding: 80px 16px 0px 16px;
  max-width: 1188px;

  &.mobile {
    padding: 40px 16px 20px 16px;
  }
}

.header-title-desktop {
  color: var(--tertiary-light-color);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
}

.header-title-mobile {
  color: var(--tertiary-light-color);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.header-subtitle-desktop {
  color: #212121;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px; /* 137.5% */
}

.header-subtitle-mobile {
  color: #212121;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
}

.mobile-product-container {
  margin-top: 24px;
}

// Vuetify v-radio-group 내부 구조 강제 변경
::v-deep .v-input--radio-group {
  margin: 0;
  padding: 0;
  .v-input__control {
    .v-input__slot {
      margin: 0;
    }
  }
  .v-messages {
    display: none !important;
  }
}
</style>
